import { render, staticRenderFns } from "./PlanDescriptions.vue?vue&type=template&id=20f6e624&scoped=true&"
import script from "./PlanDescriptions.vue?vue&type=script&lang=js&"
export * from "./PlanDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./PlanDescriptions.vue?vue&type=style&index=0&id=20f6e624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f6e624",
  null
  
)

export default component.exports